// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";

function TbItemPreview(Props) {
  var itemId = Props.itemId;
  var sizeOpt = Props.size;
  var size = sizeOpt !== undefined ? sizeOpt : 32;
  return React.createElement(ItemImage.make, {
              itemId: itemId,
              size: size
            });
}

var make = TbItemPreview;

export {
  make ,
  
}
/* react Not a pure module */
